import { render, staticRenderFns } from "./vcHeaderTitle.vue?vue&type=template&id=6b9e2b97&scoped=true&"
import script from "./vcHeaderTitle.vue?vue&type=script&lang=js&"
export * from "./vcHeaderTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9e2b97",
  null
  
)

export default component.exports